// autogenerated, do not modify

export default {
  "ActivationCode.AlreadyHasCards": "It looks like you already have an account. Please login",
  "ActivationCode.ButtonText": "次へ",
  "ActivationCode.FieldsAreRequired": "入力してください",
  "ActivationCode.FindActivationCode": "Activation CodeはSIMカード台紙の裏面をご覧ください：",
  "ActivationCode.Header": "Activation Code",
  "ActivationCode.Placeholder": "Activation Codeを入力",
  "ActivationCode.WrongFormat": "Activation Codeが無効です",
  "Axios.ConnectionError": "インターネット接続がありません。ネットワーク接続およびAPN設定をご確認ください。（APN設定欄には\"internet\"と入力が必要です。）",
  "Axios.Error": "Error {status}",
  "Axios.ServerError": "問題が発生したため復旧作業中です。時間を置いてから再度お試しください。",
  "Axios.TimeoutError": "サーバーが時間切れです。もう一度やり直してください。",
  "Common.ActivationCode": "Activation Code",
  "Common.Back": "戻る",
  "Common.Email": "メールアドレス",
  "Common.Name": "名前",
  "Common.Next": "次へ",
  "Common.Password": "パスワード",
  "Common.Phone": "電話番号",
  "Common.SIM": "SIM",
  "Confirmation.ActivateMySim": "アクティベーション",
  "Confirmation.Header": "入力内容をご確認ください",
  "ForgotPassword.BackToLogin": "サインインページに戻る",
  "ForgotPassword.ButtonText": "再設定コードを送る",
  "ForgotPassword.ChangePassword": "新しいパスワードを設定",
  "ForgotPassword.CheckYourEmailOrPhone": "新しいパスワード設定のためにメールを送信しました。ご確認ください。",
  "ForgotPassword.CheckYourPhone": "新しいパスワード設定のため、SMSを確認してください",
  "ForgotPassword.EnterEmailOrPhone": "メールアドレスを入力してください",
  "ForgotPassword.EnterNewPassword": "新しいパスワードを入力してください",
  "ForgotPassword.EnterPhone": "電話番号を入力してください",
  "ForgotPassword.Header": "パスワードの再設定",
  "ForgotPassword.NewPassword": "新しいパスワード",
  "ForgotPassword.NewPasswordConfirmation": "パスワード（確認用）",
  "ForgotPassword.PasswordAreTooWeak": "パスワードの強度が弱すぎます。強度の強いパスワードを入力してください。",
  "ForgotPassword.PasswordChanged": "パスワードの再設定が完了しました",
  "ForgotPassword.PasswordsDoesNotMatch": "パスワードが正しくありません！",
  "ForgotPassword.RecoveryTokenInvalid": "パスワード再設定リンクが期限切れです。再度パスワードの再設定を行なってください。",
  "ForgotPassword.ScoreWord-good": "標準",
  "ForgotPassword.ScoreWord-okay": "弱い",
  "ForgotPassword.ScoreWord-strong": "強い",
  "ForgotPassword.ScoreWord-stronger": "非常に強い",
  "ForgotPassword.ScoreWord-weak": "非常に弱い",
  "ForgotPassword.TryAgain": "パスワードの再設定",
  "ForgotPassword.UnableToChangePassword": "パスワードの変更ができませんでした。申し訳ございませんが、最初からやり直してください。",
  "Login.ActivateCard": "新規SIMのアクティベーション",
  "Login.AlreadyHaveAccount": "既にアカウントをお持ちです。お持ちのアカウントでログインしてください。",
  "Login.ForgotPassword": "パスワードを忘れた方はこちら",
  "Login.Header": "ログイン",
  "Login.Login": "ログイン",
  "Login.Or": "または",
  "Login.Signup": "サインアップ",
  "Login.TryLogin": "SIMカードをご利用いただくために、アカウントにサインインしてください。アカウントをまだお持ちでない場合はアカウント登録をしてください。",
  "Menu.ContactUs": "お問い合せ",
  "Menu.Coverage": "ご利用可能エリア",
  "Menu.Faq": "よくあるご質問",
  "Menu.HowItWorks": "ご利用の流れ",
  "Menu.Pricing": "価格",
  "Register.AlreadyHaveAccount": "既にアカウントをお持ちの場合 ",
  "Register.ButtonText": "登録",
  "Register.ChooseFile": "ファイルを選択",
  "Register.ConfirmEmail": "メールアドレス（確認用）",
  "Register.ConfirmPassword": "パスワード（確認用）",
  "Register.ConfirmPhone": "電話番号（確認用）",
  "Register.Country": "国名 ",
  "Register.Email": "メールアドレス",
  "Register.EmailWrongFormat": "メールアドレスが正しくありません",
  "Register.EmailsDontMatch": "メールアドレスが正しくありません",
  "Register.FirstName": "名",
  "Register.FirstNameHint": "ローマ字で入力",
  "Register.Header": "お客様情報を入力してください",
  "Register.IdentityHint": "（任意：後からでも可）",
  "Register.LastName": "姓",
  "Register.LastNameHint": "ローマ字で入力",
  "Register.NonLatinError": "英数字および句読点のみ",
  "Register.Password": "パスワード",
  "Register.PasswordsDontMatch": "パスワードが正しくありません",
  "Register.Phone": "電話番号",
  "Register.PhoneHint": "国番号+81の後、電話番号の最初の0を抜いて入力してください。",
  "Register.PhonesDontMatch": "電話番号が正しくありません",
  "Register.ShortPassword": "パスワードが短すぎます（最低6文字）",
  "Register.ShouldAgreeWithTerms": "Terms & Conditionsに同意して下さい",
  "Register.TermsAndConditions": "MTX ConnectのTerms & Conditionsに同意して進む",
  "Register.UploadIdentity": "本人確認書類のスキャンをアップロードする",
  "Register.UploadWrongFormat": "jpgファイルを選択してください",
  "Register.countryEmpty": "国名を入力してください",
  "Register.emailEmpty": "メールアドレスを入力してください",
  "Register.firstNameEmpty": "名を入力してください",
  "Register.lastNameEmpty": "姓を入力してください",
  "Register.passwordEmpty": "パスワードを入力してください",
  "Register.phoneEmpty": "電話番号を入力してください",
  "Shared.ErrorPhoneMsg": "Please use valid phone number",
  "Verify.Title": "お客様のメールアドレスを確認しました",
}



// WEBPACK FOOTER //
// ./app/javascript/components/application/locales/ja.js